export const ROLES = {
    SUPER_ADMIN: 'PLATFORM_SUPER_ADMIN',
    ADMIN: 'ORG_ADMIN',
    CS: 'CS',
    OPS: 'OPS',
    CUSTOMER: 'CUSTOMER'
} as const;

export type UserRole = typeof ROLES[keyof typeof ROLES];
